import React from "react";
import { Button, Grid, Icon } from "semantic-ui-react";
import BCModal from "../ui/BCModal";

interface IBCConfirmationModal {
  isModalOpen: boolean;
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  modalHeader?: string;
  modalContent?: string;
  confirmButtonWord?: string;
  handleConfirm: any;
  cancelButtonWord?: string;
  handleCancel?: any;
  isWarning?: boolean;
}

const BCConfirmationModal = ({
  isModalOpen, 
  setIsModalOpen, 
  modalHeader, 
  modalContent,
  confirmButtonWord,
  handleConfirm,
  cancelButtonWord,
  handleCancel,
  isWarning
} : IBCConfirmationModal) => {
  return (
    <BCModal
      size="tiny"
      headerClass={isWarning && "warning-modal-header"}
      isModalOpen={isModalOpen}
      onClose={() => setIsModalOpen(false)}
      onOpen={() => setIsModalOpen(true)}
      header={<React.Fragment>{isWarning && <Icon name="warning sign" color="yellow" />}{modalHeader}</React.Fragment>}
      content={<p>{modalContent}</p>}
      actions={<Grid>
        <Grid.Row>
          <Grid.Column width={8}>
            <Button
              fluid
              onClick={() => {handleCancel ? handleCancel() : setIsModalOpen(false);}}
            >
              <div className="gmr-button-container">
                <div className="gmr-button-text">{cancelButtonWord || "Cancel"}</div>
              </div>
            </Button>
          </Grid.Column>
          <Grid.Column width={8}>
            <Button
              className="bp-button"
              color={isWarning ? "yellow" : undefined}
              fluid
              onClick={() => handleConfirm()}
            >
              <div className="gmr-button-container">
                <div className={`gmr-button-text ${isWarning && "warning-button-text"}`}>{confirmButtonWord || "Yes"}</div>
              </div>
            </Button>
          </Grid.Column>
        </Grid.Row>
      </Grid>}
    />
  );
};

export default BCConfirmationModal;